import i18next, {t} from "i18next";

export const convert = (key, rest) => {
  return i18next.t(key, { ...rest });
};
